import { Breadcrumbs } from 'components/city-blocks/breadcrumbs';
import { generateThumborImgUrl } from 'components/dynamic-image';
import { ZipCodeInput } from 'components/hero-block/zip-code-input';
import Head from 'next/head';
import React from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { Crumb } from 'utils/breadcrumb-util';
import { getFrontEndUrl } from 'utils/environment-util';

const IMAGE_SRC = 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/food_bg.jpg';
const LARGE_IMAGE_SRC = generateThumborImgUrl({ src: IMAGE_SRC, width: 1200, height: 253 });

// TODO: Gil Note: We currently don't have different images optimized for different breakpoints, so we'll just use the
//                large version for now. Once we have optimized images, we can swap in different img srcs and dimensions
// const MEDIUM_IMAGE_SRC = generateThumborImgUrl({ src: IMAGE_SRC, width: 768, height: 163 });
// const SMALL_IMAGE_SRC = generateThumborImgUrl({ src: IMAGE_SRC, width: 576, height: 122 });

interface IProps {
  className?: string;
  heroText: React.ReactNode;
  crumbs: Crumb[];
  zipCode?: string;
  prefillZipCode?: boolean;
}

export const HeroBlock: React.FC<IProps> = ({ className, heroText, crumbs, zipCode, prefillZipCode }) => {
  return (
    <>
      <Head>
        <link rel='preload' media='(min-width: 768px)' href={LARGE_IMAGE_SRC} as='image' />
        {/* <link rel='preload' media='(min-width: 576px) and (max-width: 767px)' href={MEDIUM_IMAGE_SRC} as='image' /> */}
        {/* <link rel='preload' media='(max-width: 576px)' href={SMALL_IMAGE_SRC} as='image' /> */}
      </Head>
      <div className={`relative flex h-full w-full flex-col p-4 py-10 md:px-24 md:py-16 ${className} `}>
        <div className='absolute inset-0 z-0 h-full w-full'>
          <picture className='absolute top-0 h-full w-full'>
            {/* TODO: Gil Note: We currently don't have different images optimized for different breakpoints, so we'll */}
            {/*                 just use the large version for now. Once we have optimized images, we can swap in */}
            {/*                 different img srcs and dimensions */}
            {/* <source media='(min-width: 768px)' srcSet={LARGE_IMAGE_SRC} /> */}
            {/* <source media='(min-width: 576px) and (max-width: 767px)' srcSet={MEDIUM_IMAGE_SRC} /> */}
            {/* <img */}
            {/*  className='absolute top-0 h-full w-full object-cover object-center' */}
            {/*  src={SMALL_IMAGE_SRC} */}
            {/*  alt='Hero image' */}
            {/* /> */}
            <img
              className='absolute top-0 h-full w-full object-cover object-center'
              src={LARGE_IMAGE_SRC}
              alt='Hero image'
            />
          </picture>
        </div>

        <Breadcrumbs className='z-10 mb-6 rounded-lg backdrop-blur' crumbs={crumbs} />
        <h1
          className='z-10 mb-6 w-full text-[40px] font-bold leading-[48px] text-white drop-shadow-sm md:text-[64px] md:leading-[68px]'
          data-testid='hero-block-header'>
          {heroText}
        </h1>

        <ZipCodeInput className='z-10 mb-5' defaultZipCode={zipCode} prefillZipCode={prefillZipCode} />

        <span className='z-10 flex flex-row gap-2 text-base text-white'>
          <span className='font-medium'>Already have an account?</span>
          <NoFollowLink href={`${getFrontEndUrl()}/login`} className='font-bold underline'>
            Log in
          </NoFollowLink>
        </span>
      </div>
    </>
  );
};
